<i18n>
{
    "en": {
        "version": "version",
        "code": "codename"
    },
    "ua": {
        "version": "версія",
        "code": "внутрішнє ім'я"
    },
    "ru": {
        "version": "версия",
        "code": "внутреннее имя"
    }
}
</i18n>

<template>
  <component
    :is="require('../../_snippets/popup/popup_912x616').default"
    :visible.sync="opened"
  >
    <template slot="content">
      <el-container>
        <el-aside>
          <div class="widget-info">
            <el-image
              class="widget-image"
              :src="widget.image"
              fit="cover"
              :lazy="false"
            />
            <div class="widget-name" v-html="widget.name"></div>
            <div
              class="widget-desc widget-info"
              v-html="widget.short_description"
            ></div>
            <slot name="widget-info" v-bind:widget="widget"></slot>
          </div>
          <slot name="actions" v-bind:widget="widget"></slot>
        </el-aside>
        <el-main>
          <slot name="main" v-bind:widget="widget"></slot>
        </el-main>
      </el-container>
    </template>
  </component>
</template>

<script>
export default {
  name: "widget_details_popup",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    widget: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    opened: {
      get: function() {
        return this.visible;
      },
      set: function(v) {
        this.$emit("update:visible", v);
      }
    }
  }
};
</script>

<style lang="stylus">
.widget-details-popup {
    & aside {
        width: 258px !important;
        background: #f0f0f0;
        border: 1px solid #d3d7d8;
        border-right: none;
        padding: 33px 28px 0;

        & > .widget-info {
            padding-bottom: 18px;

            & > .widget-image:first-child {
                border-radius: 5px;
            }

            & > .widget-name {
                font-size: 24px;
                font-weight: bold;
                margin: 1rem 0;
            }

            & > .widget-dev {
                margin-top: 1rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .widget-col {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .widget-val {
                        font-weight: 400;
                        font-size: 1.1rem;

                        .git-icon {
                            cursor: pointer;
                            color: #F05133;
                        }
                    }

                    .widget-text {
                        font-size: 0.7rem;
                        font-weight: 300;
                    }

                    &.repo {
                        flex: 0 0;
                    }
                }
            }
        }
    }

    & main {
        height: 100%;
        background-color: #ffffff;
        border: 1px solid #d3d7d8;
        padding: 33px 28px 0;
        width: 100%;
    }
}
</style>
